import { render, staticRenderFns } from "./ImageOrientation.vue?vue&type=template&id=288ea019&scoped=true&"
import script from "./ImageOrientation.vue?vue&type=script&lang=js&"
export * from "./ImageOrientation.vue?vue&type=script&lang=js&"
import style0 from "./ImageOrientation.vue?vue&type=style&index=0&id=288ea019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ea019",
  null
  
)

export default component.exports